__turbopack_context__.v({
  "body": "styles-module__c0zYOW__body",
  "bodyNarrow": "styles-module__c0zYOW__bodyNarrow",
  "center": "styles-module__c0zYOW__center",
  "extraSpacing": "styles-module__c0zYOW__extraSpacing",
  "heading": "styles-module__c0zYOW__heading",
  "left": "styles-module__c0zYOW__left",
  "right": "styles-module__c0zYOW__right",
  "textContent": "styles-module__c0zYOW__textContent",
  "wrapper": "styles-module__c0zYOW__wrapper",
});
